import React, {useState} from 'react';
import * as PropTypes from 'prop-types';
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {useTranslation} from "react-i18next";

export default function RowActionsMenu({onEdit, onDelete}) {
    const {t} = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        if (event) {
            event.stopPropagation();
        }
        setAnchorEl(null);
    };

    const handleEdit = (event) => {
        handleClose(event);
        onEdit();
    };

    const handleDelete = (event) => {
        handleClose(event);
        onDelete();
    };

    return (
        <>
            <IconButton size="small" onClick={handleOpen} aria-label={t("Actions")}>
                <MoreVertIcon fontSize="small"/>
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={handleEdit}>{t("Edit")}</MenuItem>
                <MenuItem onClick={handleDelete}>{t("Delete")}</MenuItem>
            </Menu>
        </>
    );
}

RowActionsMenu.propTypes = {
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};
